import { component } from 'picoapp';
import Drawer from '../../utils/drawer';
import Ready from '../../../js/utils/ready';
import { addVariant } from '../../../js/lib/cart';
import toggleAddToCartBtn from '../../../js/lib/add-to-cart-btn';

export default component(async (node) => {

  const AddToCartBtn = node.querySelector('.js-formAddToCartBtn');
  const formAddToCartBtn = AddToCartBtn.closest('form');
  const fitSizeSelectionBtn = document.querySelector('.js-fitSizeSelectionBtn');
  const mainProductsection = document.querySelector('section.product');
  const productInfo = document.querySelector('[product-info]');
  const productSelection = document.querySelector('[product-selection]');
  const productSelectionInforWrapper = document.querySelector('.product__selection');


  const addProductToCart = (e) => {
      e.preventDefault();
      toggleAddToCartBtn(AddToCartBtn, false);
      fitSizeSelectionBtn.click();
      toggleAddToCartBtn(AddToCartBtn, true);
  };

  const toggleSectionOnScroll = () => {
    const mainProductSectionHeight = parseFloat(mainProductsection.getBoundingClientRect().height);
    const productInfoHeight = parseFloat(productInfo.getBoundingClientRect().height) ;
    const productSelectionHeight = parseFloat(productSelection.getBoundingClientRect().height);
    const mainProductRightSectionHeight = productInfoHeight + productSelectionHeight;
    
    window.addEventListener('scroll', function () {

      const currentScrollPosY = window.scrollY;
      const screenWidth = screen.width;

      if(screenWidth > 767){
        if (currentScrollPosY >= parseFloat(mainProductSectionHeight - mainProductRightSectionHeight)) {
          node.classList.remove('opacity-0');
          node.classList.add('opacity-1');
        }
        else {
          node.classList.add('opacity-0');
          node.classList.remove('opacity-1');
        }
      }
      else {
        if (currentScrollPosY >= mainProductSectionHeight - productInfoHeight) {
          node.classList.remove('opacity-0');
          node.classList.add('opacity-1');
        }
        else {
          node.classList.add('opacity-0');
          node.classList.remove('opacity-1');
        }
      }
     
    })
  }


  
  const init = () => {
    Ready(() => {
      formAddToCartBtn.addEventListener('submit', (e) => addProductToCart(e));
      toggleSectionOnScroll();
    });
  };

  init();
});
